import { observer } from 'mobx-react-lite'
import { ContainerActions } from 'shared/ui'
import { DropdownFilter } from 'features/DropdownFilter'
import { DropdownOrder } from 'features/DropdownOrder'
import { useSectionConversationContext } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation/context/sectionConversationContext'
import styles from './styles.module.scss'

export const ConversationFilters = observer(() => {
  const store = useSectionConversationContext()

  if (store.hideFilter) return null

  return (
    <div className={styles.wrap}>
      <ContainerActions
        disabled={store.loading}
        padding='8px 2px 0 8px'
        leftActions={[
          {
            iconButtonComponent: <DropdownFilter store={store.filtersStore} />,
          },
        ]}
        rightActions={[{ iconButtonComponent: <DropdownOrder store={store.ordersStore} /> }]}
      />
    </div>
  )
})
